import axios from "axios"
import { SOURCE_ORIGIN } from "@/constants"
import { resolveHttpTimeoutMs } from "@/utils/httpTimeout"

const aemApiBaseUrl =
  process.env.AEM_API ||
  process.env.AUTHORBASEURL ||
  process.env.NEXT_PUBLIC_AUTHORBASEURL ||
  ""

const aemModelJsonBaseUrl = process.env.AEM_MODEL_JSON_API || aemApiBaseUrl
const httpTimeoutMs = resolveHttpTimeoutMs(process.env.HTTP_TIMEOUT_MS)

const createAemServerAxiosInstance = ({ baseURL = "" } = {}) => {
  return axios.create({
    baseURL,
    timeout: httpTimeoutMs,
    headers: {
      "Content-type": "application/json",
      KohlerTarget: "AzureApp",
    },
  })
}

const createSourceOriginInterceptor = fallbackOrigin => async config => {
  config.headers = config.headers || {}
  if (!config.headers["X-Source-Origin"]) {
    if (config.headers?.common?.["Ocp-Apim-Subscription-Key"]) {
      config.headers["X-Source-Origin"] = SOURCE_ORIGIN ?? fallbackOrigin ?? ""
    }
  }

  return config
}

export const aemServerAxiosInstance = createAemServerAxiosInstance({
  baseURL: aemApiBaseUrl,
})
export const aemServerModelJsonAxiosInstance = createAemServerAxiosInstance({
  baseURL: aemModelJsonBaseUrl,
})

aemServerAxiosInstance.interceptors.request.use(
  createSourceOriginInterceptor(aemApiBaseUrl)
)

aemServerModelJsonAxiosInstance.interceptors.request.use(
  createSourceOriginInterceptor(aemModelJsonBaseUrl)
)

export const getAemServerAxiosInstance = () => aemServerAxiosInstance

export const getAemServerModelJsonAxiosInstance = () =>
  aemServerModelJsonAxiosInstance

export const callAemServerApi = async ({ config } = {}) =>
  getAemServerAxiosInstance()(config)

export const callAemServerModelApi = async ({ config } = {}) =>
  getAemServerModelJsonAxiosInstance()(config)
